import { makeEnum } from '@transcend-io/type-utils';

export const DiscoClassScanType = makeEnum({
  SchemaOnly: 'SCHEMA_ONLY',
  FullScan: 'FULL_SCAN',
  ClassificationOnly: 'CLASSIFICATION_ONLY',
});

/** Overload type */
export type DiscoClassScanType =
  (typeof DiscoClassScanType)[keyof typeof DiscoClassScanType];

export const DiscoClassScanStatus = makeEnum({
  InProgress: 'IN_PROGRESS',
  Paused: 'PAUSED',
  Complete: 'COMPLETE',
  Disconnected: 'DISCONNECTED',
  Error: 'ERROR',
  Stopped: 'STOPPED',
});

/** Overload type */
export type DiscoClassScanStatus =
  (typeof DiscoClassScanStatus)[keyof typeof DiscoClassScanStatus];

export const DiscoClassScanAction = makeEnum({
  Start: 'START',
  Pause: 'PAUSE',
  Resume: 'RESUME',
  Stop: 'STOP',
  Restart: 'RESTART',
});

/** Overload type */
export type DiscoClassScanAction =
  (typeof DiscoClassScanAction)[keyof typeof DiscoClassScanAction];

/** Supported classification browse list quick filters */
export enum ClassificationBrowseListQuickFilter {
  RecurringScansOn = 'RECURRING_SCANS_ON',
  RecurringScansOff = 'RECURRING_SCANS_OFF',
  Disconnected = 'DISCONNECTED',
  NotConfigured = 'NOT_CONFIGURED',
  Error = 'ERROR',
}
